export default __webpack_public_path__ + "static/media/work-colored.450280ea.svg";